// removed by extract-text-webpack-plugin
module.exports = {"loader":"Spinner__loader","loader-svg":"Spinner__loader-svg","loaderSvg":"Spinner__loader-svg","path":"Spinner__path","loading-spinner":"Spinner__loading-spinner","loadingSpinner":"Spinner__loading-spinner","loading-spinner-inner":"Spinner__loading-spinner-inner","loadingSpinnerInner":"Spinner__loading-spinner-inner","loading-spinner-outer":"Spinner__loading-spinner-outer","loadingSpinnerOuter":"Spinner__loading-spinner-outer"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Spinner/Spinner.scss
// module id = 1649
// module chunks = 8